import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _Loading2 from "element-ui/lib/theme-chalk/loading.css";
import "element-ui/lib/theme-chalk/base.css";
import _Loading from "element-ui/lib/loading";
import _classCallCheck from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/createClass";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.reflect.delete-property.js";
import { toLogin, kickLogin } from '@/utils/login';
import { toSuspended } from '@/utils/suspended'; // 不需要处理返回值的接口

var noDealResponse = new Set(['/account/user_logout']);

var LoadingFunc = /*#__PURE__*/function () {
  function LoadingFunc() {
    _classCallCheck(this, LoadingFunc);

    this.loadingTimes = 0;
    this.loading = null;
  }

  _createClass(LoadingFunc, [{
    key: "add",
    value: function add(loadingText) {
      this.loadingTimes++;

      if (!this.loading || this.loadingTimes > 0) {
        this.loading = _Loading.service({
          fullscreen: true,
          background: 'transparent',
          text: loadingText || '加载中…'
        });
      }
    }
  }, {
    key: "reduce",
    value: function reduce() {
      if (--this.loadingTimes <= 0) {
        this.clear();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.loading.close();
      this.loading = null;
      this.loadingTimes = 0;
    }
  }]);

  return LoadingFunc;
}();

var AxiosBlocker = /*#__PURE__*/function () {
  function AxiosBlocker(loading) {
    _classCallCheck(this, AxiosBlocker);

    this.pending = [];
    this.loading = loading;
  } // 请求拦截


  _createClass(AxiosBlocker, [{
    key: "blockRequest",
    value: function () {
      var _blockRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config.baseURL = process.env.VUE_APP_BASE_API;
                return _context.abrupt("return", config);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function blockRequest(_x) {
        return _blockRequest.apply(this, arguments);
      }

      return blockRequest;
    }() // 请求错误拦截

  }, {
    key: "blockRequestError",
    value: function blockRequestError(error) {
      Promise.reject(error);
    } // 返回数据拦截

  }, {
    key: "blockResponse",
    value: function blockResponse(response) {
      return response;
    } // 返回数据错误拦截

  }, {
    key: "blockResponseError",
    value: function blockResponseError(responseErr) {
      return responseErr;
    }
  }, {
    key: "addPending",
    value: function addPending(c) {
      this.pending.push(c);
    }
  }, {
    key: "dealResponseError",
    value: function dealResponseError(responseErr) {
      var reduceLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var showMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (reduceLoading) {
        this.loading.reduce();
      }

      if (showMessage) {
        var _responseErr$response, _responseErr$response2, _responseErr$response3;

        var statusCode = responseErr === null || responseErr === void 0 ? void 0 : (_responseErr$response = responseErr.response) === null || _responseErr$response === void 0 ? void 0 : _responseErr$response.status;
        var errorMessage = (responseErr === null || responseErr === void 0 ? void 0 : (_responseErr$response2 = responseErr.response) === null || _responseErr$response2 === void 0 ? void 0 : (_responseErr$response3 = _responseErr$response2.data) === null || _responseErr$response3 === void 0 ? void 0 : _responseErr$response3.message) || '系统异常，请稍后重试';
        var message = "".concat(errorMessage, " (").concat(statusCode, ")");

        _Message({
          message: message,
          type: 'error',
          duration: 5 * 1000
        });
      }

      return responseErr;
    }
  }, {
    key: "dealResponse",
    value: function dealResponse(response) {
      var showMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var data = response.data;

      if (data.status === 0) {
        showMessage && _Message({
          message: data.message,
          type: 'error',
          duration: 5 * 1000
        });
      }

      if (data.status === 2) {
        showMessage && _Message({
          message: data.message,
          type: 'error',
          duration: 5 * 1000
        });
      }

      if (data.status === 3) {
        // 登录超时，接口请求多次，导致弹框会多次出现，只弹一次
        while (this.pending.length > 0) {
          this.pending.pop()('请求中断');
          localStorage.setItem('webLoginMessage', data.message);
          toLogin();
        }
      }

      if (data.status === 4) {
        showMessage && _Message({
          message: '权限不正确，请退出重新进入',
          type: 'error',
          duration: 5 * 1000
        });
      }

      if (data.status === 5) {
        showMessage && _Message({
          message: data.message,
          type: 'error',
          duration: 5 * 1000
        });
      }

      if (data.status === 6) {
        while (this.pending.length > 0) {
          this.pending.pop()('请求中断');
          kickLogin(data);
        }
      }

      if (data.status === 8) {
        // 停机服务
        toSuspended(data.haltTimestamp);
      }

      return response;
    }
    /**
     * @description: 描述信息
     * @param {response} axios返回数据，type AxiosResponse | AxiosError 分别是正常返回和错误返回数据
     * @param {reduceLoading} 是否要减少一次loadngTimes
     * @param {showMessage} 是否显示错误信息
     * @return {CustomResponse} 返回数据or抛出错误，最上层会catch的
     */

  }, {
    key: "getResponseData",
    value: function getResponseData(response) {
      var reduceLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var showMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (noDealResponse.has(response.config.url)) {
        if (reduceLoading) {
          this.loading.reduce();
        }

        return response;
      }

      if (response instanceof Error) {
        // 这里把PromiseError返回替换成返回一组空数据status设置成0
        var _this$dealResponseErr = this.dealResponseError(response, reduceLoading, showMessage),
            message = _this$dealResponseErr.message;

        return {
          status: 0,
          message: message,
          data: null
        };
      } else {
        if (reduceLoading) {
          this.loading.reduce();
        }

        response = this.dealResponse(response, showMessage);
        return response.data;
      }
    }
  }]);

  return AxiosBlocker;
}();
/**
 * @description: 把非Request的参数剔除出来
 * @param {CombineRequestOption} option
 * @return {*}
 */


var dealMethodsOption = function dealMethodsOption(option) {
  var extend = {
    noLoading: option.noLoading,
    noMessage: option.noMessage,
    loadingText: option.loadingText
  };
  Reflect.deleteProperty(option, 'noLoading');
  Reflect.deleteProperty(option, 'noMessage');
  Reflect.deleteProperty(option, 'loadingText');
  return extend;
};

var loading = new LoadingFunc();
var blocker = new AxiosBlocker(loading);
export { loading, blocker, dealMethodsOption };